// extracted by mini-css-extract-plugin
module.exports = {"layout":"_25d45facb5--layout--TjvSZ","spinner":"_25d45facb5--spinner--uIpxO","container":"_25d45facb5--container--O_TQ1","error":"_25d45facb5--error--bfnyQ"};